import defaultTheme from './defaultTheme'
export default defaultTheme
